<template>
  <div>
    <!-- 大客户看板两个导出共用（REQ-2026-107511）：周报按月、明细按客户姓名 -->
    <el-form :inline="true" size="small">
      <el-form-item v-if="isWeekly" label="月份：">
        <el-date-picker v-model="month" type="month" value-format="yyyy-MM"
                        :clearable="false"
                        style="width:130px" />
      </el-form-item>
      <el-form-item v-else label="客户：">
        <el-input v-model="keyword" placeholder="客户姓名，空为全部" clearable style="width:180px" />
      </el-form-item>
      <el-form-item v-if="!isWeekly" label="统计时间：">
        <el-date-picker v-model="dateRange" type="daterange" value-format="yyyy-MM-dd"
                        range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                        style="width:270px" />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" size="mini" plain :loading="saving" @click="handleDownload">导出</el-button>
      </el-form-item>
    </el-form>
    <div v-if="!isWeekly && dateRange && dateRange.length === 2" class="range-tip">导出所选区间的业绩与服务次数；余额为当前实时值。清空时间保留原统计口径。</div>
  </div>
</template>

<script>
import bigCustomerBoardApi from '@/api/count/bigCustomerBoard'

export default {
  props: { code: { type: String, default: "" } },
  data() {
    return {
      month: this.$route.query.month || this.dayjs().format('YYYY-MM'),
      keyword: this.$route.query.keyword || '',
      dateRange: this.$route.query.startDate && this.$route.query.endDate ? [this.$route.query.startDate, this.$route.query.endDate] : [],
      saving: false
    }
  },
  computed: {
    isWeekly() { return this.code === 'EEForBigCustomerWeekly' }
  },
  methods: {
    handleDownload() {
      if (this.saving) return
      const range = this.dateRange && this.dateRange.length === 2 ? { startDate: this.dateRange[0], endDate: this.dateRange[1] } : {}
      this.saving = true
      return this.$common.confirm('是否确认导出')
        .then(() => this.isWeekly
          ? bigCustomerBoardApi.exportWeekly(this.month)
          : bigCustomerBoardApi.exportDetail(this.keyword || undefined, range))
        .then(res => {
          if (res.code === '0') {
            setTimeout(() => this.$emit('created'), 500)
          }
        }).finally(() => { this.saving = false })
    }
  }
}
</script>
<style scoped>.range-tip { margin-bottom: 10px; color: #606266; }</style>
